export const LOCAL_STORAGE_FAV_PROJECT_KEY_PART = 'favouriteProjects';
